<label class="date-time" i18n>Exam Date*  
   <fa-icon [icon]="infoCircle" i18n-matTooltip matTooltip="The exact date you want your exam session to start." matTooltipPosition="right">
   </fa-icon>
</label>
<br>
<mat-form-field class="select-one">
   <input i18n-matInput matInput [formControl]="dateTimeControl" type="datetime-local" placeholder="start date">
</mat-form-field>
